module.exports = __webpack_public_path__ + "img/actinspace.1bc07388.jpg";